import React from 'react';
import { connect } from 'react-redux';

import { getInfo } from '../../redux/auth/user/actions';
import { selectIsStatusInitial } from '../../redux/auth/user/selectors';

import UserDataGate from './UserDataGate';

const UserDataGateConnected = (props) => <UserDataGate {...props} />;

const mapStateToProps = (state) => ({
  isStatusInitial: selectIsStatusInitial(state),
});

const mapActionsToProps = {
  getInfo,
};

export default connect(mapStateToProps, mapActionsToProps)(UserDataGateConnected);
